import React, { useEffect } from 'react';
import styles from './S1.module.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import mobileVideo from './assets/video/calificadorCorregido.mp4';
import defaultVideo from './assets/video/calificador.mp4';
import backgroundVideo from './assets/video/fondo4.mp4';

const VideoComponent = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
    console.log('AOS initialized');
  }, []);

  return (
    <div className={styles.container}>
      <video className={styles.backgroundVideo} autoPlay loop muted playsInline>
        <source src={backgroundVideo} type="video/mp4" />
        Tu navegador no soporta el video.
      </video>
      <div className={styles.contentWrapper}>
        
        <div className={styles.videoTextContainer} data-aos="fade-up">
          <div className={styles.textContainer}>
            <h2 className={styles.title}>CalificadorIA</h2>
            <p className={styles.description}>Experimenta la última tecnología para calificar trabajos.</p>
          </div>
        </div>
        
        <div className={styles.videoContainer}>
          <video autoPlay loop playsInline muted className={`${styles.computerVideo} ${styles.defaultVideo}`}>
            <source src={defaultVideo} type="video/mp4" />
          </video>
          <video autoPlay loop playsInline muted className={`${styles.phoneVideo} ${styles.mobileVideo}`}>
            <source src={mobileVideo} type="video/mp4" />
          </video>
        </div>

      </div>
    </div>
  );
}

export default VideoComponent;